import { render, staticRenderFns } from "./AttachPackModal.vue?vue&type=template&id=2710d1b1"
import script from "./AttachPackModal.vue?vue&type=script&lang=js"
export * from "./AttachPackModal.vue?vue&type=script&lang=js"
import style0 from "./AttachPackModal.vue?vue&type=style&index=0&id=2710d1b1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports